import { Building2, Home } from "lucide-react";
import { useWizard } from "../../Contexts/WizardContext";
import { Button } from "../General/Button";
import { useState } from "react";

export default function PropertyTypeTCM() {
    const {formData, nextStep, previousStep, updateFormData} = useWizard()

    const [selected, setSelected] = useState(formData?.propertyType || null);

    const options = [
        { value: "single-family", label: "Single Family Home", icon: Home },
        { value: "commercial", label: "Commercial / HOA", icon: Building2 },
    ];
    
    const handleContinue = () => {
        updateFormData(oldVal => {
            return {
                ...oldVal,
                propertyType: selected
            }
        })
        nextStep()
    }
    return (
        <div className="w-full max-w-2xl mx-auto p-4">
          <div className="text-center mb-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
              Property Type
            </h2>
            <p className="text-gray-600">What is your property type?</p>
          </div>
          
            <div className="space-y-6">
                
                {/* Options */}
                <div className="flex gap-4 justify-center mb-8">
                {options.map(({ value, label, icon: Icon }) => (
                    <button
                    key={value}
                    onClick={() => setSelected(value)}
                    className={`flex-1 max-w-xs flex flex-col items-center gap-3 p-7 rounded-xl border-2 transition-all duration-200 cursor-pointer
                        ${selected === value
                        ? "border-green-600 bg-green-50 text-green-700"
                        : "border-gray-200 bg-white text-gray-700 hover:border-gray-300"}`}
                    >
                    <Icon size={40} strokeWidth={1.8} className={selected === value ? "text-green-600" : "text-gray-400"} />
                    <span className="text-base font-semibold">{label}</span>
                    </button>
                ))}
                </div>
            
                <div className="flex gap-4 mt-6">
                    <Button
                        label='Back'
                        onClick={previousStep}
                    />
                    <Button
                        label='Continue'
                        onClick={handleContinue}
                        isDisabled={!selected}
                        primary
                    />
                </div>
            </div>
          
        </div>
      );
}